// 私有接口部分
import $axios from '@/assets/js/request'
/** login  */
export const getIndexPagesData = function (params) {
  return $axios({
    url: '/api/yn/index/data',
    method: 'GET',
    params
  })
}
export const getIndexCrowData = function (params) {
  return $axios({
    url: '/api/yn/index/cowshed',
    method: 'GET',
    params
  })
}
//智慧牧场-牧场情况
export const getRanchTopData = function (params) {
  return $axios({
    url: '/api/yn/ranch/situation',
    method: 'GET',
    params
  })
}
//全局通用-牛舍的折线图数据
export const getCrowHourseCharts = function (params) {
  return $axios({
    url: '/api/yn/index/cowshed_data',
    method: 'GET',
    params
  })
}
//全局通用-牛舍列表
export const getCrowHourse = function (params) {
  return $axios({
    url: '/api/yn/ranch/cowshed',
    method: 'GET',
    params
  })
}
//智慧牧场-防疫管理
export const getRanchJianyi= function (params) {
  return $axios({
    url: '/api/yn/ranch/janyi_list',
    method: 'GET',
    params
  })
}

//智慧牧场-防疫管理
export const getRanchMianyi= function (params) {
  return $axios({
    url: '/api/yn/ranch/mianyi_list',
    method: 'GET',
    params
  })
}
//牛只管理-牛只总览
export const getCrowData= function (params) {
  return $axios({
    url: '/api/yn/cow/index',
    method: 'GET',
    params
  })
}
//牛只管理-牛只总览
export const getCrowTotalData= function (params) {
  return $axios({
    url: '/api/yn/cow/list',
    method: 'GET',
    params
  })
}
//牛只管理-通过牛编号获取牛详情
export const getCrowDetailData= function (params) {
  return $axios({
    url: '/api/yn/cow/detail',
    method: 'GET',
    params
  })
}
//牛只管理-通过牛编号获取牛详情
export const getCrowTableData= function (params) {
  return $axios({
    url: '/api/yn/cow/health',
    method: 'GET',
    params
  })
}

//牛只管理-健康状况-温度和采食量表数据
export const getWdChartsData= function (params) {
  return $axios({
    url: '/api/yn/cow/wd_cs',
    method: 'GET',
    params
  })
}
//牛只管理-健康状况-温度和采食量表数据
export const getYdChartsData= function (params) {
  return $axios({
    url: '/api/yn/cow/yd_fc',
    method: 'GET',
    params
  })
}
//中央厨房-料单管理列表
export const getKitChenData= function (params) {
  return $axios({
    url: '/api/yn/kitchen/basic_data',
    method: 'GET',
    params
  })
}
//中央厨房-料单管理列表
export const getKitChenTable= function (params) {
  return $axios({
    url: '/api/yn/kitchen/bill',
    method: 'GET',
    params
  })
}
//中央厨房-料单管理列表
export const getKitChenDownTable= function (params) {
  return $axios({
    url: '/api/yn/kitchen/weighbridge',
    method: 'GET',
    params
  })
}
//养母繁犊-合作繁育
export const getCalfTopData= function (params) {
  return $axios({
    url: '/api/yn/breed/cooperate',
    method: 'GET',
    params
  })
}
//养母繁犊-合作繁育2
export const getCalfTopData2= function (params) {
  return $axios({
    url: '/api/yn/breed/fanyu',
    method: 'GET',
    params
  })
}
//中央厨房-料单管理列表
export const getCalfDownData= function (params) {
  return $axios({
    url: '/api/yn/breed/insurance',
    method: 'GET',
    params
  })
}
//中央厨房-料单管理列表
export const getCalfDownDataList= function (params) {
  return $axios({
    url: '/api/yn/breed/insurance_list',
    method: 'GET',
    params
  })
}
//新闻详情
export const getNewsPageDetail= function (params) {
  return $axios({
    url: '/api/yn/index/news',
    method: 'GET',
    params
  })
}

//首页侧视图
export const indexCorwYnPic= function (params) {
  return $axios({
    url: '/api/yn/index/pic',
    method: 'GET',
    params
  })
}
//牛舍的摄像头
export const crowHourseShexiangtou= function (params) {
  return $axios({
    url: '/api/yn/index/shexiangtou',
    method: 'GET',
    params
  })
}
//饲料单明细
export const crowSiliaoData= function (params) {
  return $axios({
    url: '/api/yn/Kitchen/bill_detail',
    method: 'GET',
    params
  })
}

//中央厨房摄像头
export const foodShexiangtou= function (params) {
  return $axios({
    url: '/api/yn/kitchen/shexiangtou',
    method: 'GET',
    params
  })
}

//中央厨房摄像头
export const deviceData= function (params) {
  return $axios({
    url: '/api/yn/index/devices',
    method: 'GET',
    params
  })
}
//销售溯源 商品列表
export const traceTableData= function (params) {
  return $axios({
    url: '/api/yn/product/list',
    method: 'GET',
    params
  })
}
//销售溯源 商品列表
export const traceLeftData= function (params) {
  return $axios({
    url: '/api/yn/product/left',
    method: 'GET',
    params
  })
}
//销售溯源 商品列表
export const traceRightData= function (params) {
  return $axios({
    url: '/api/yn/product/type',
    method: 'GET',
    params
  })
}



//屠宰加工摄像头
export const slaughterShexiangtou= function (params) {
  return $axios({
    url: '/api/yn/tuzai/shexiangtou',
    method: 'GET',
    params
  })
}
//养母繁犊-金融机构页面左侧两个板块数据
export const jinrongjgData= function (params) {
  return $axios({
    url: '/api/yn/breed/insurance_basic',
    method: 'GET',
    params
  })
}
//养母繁犊-金融机构页面左侧两个板块数据
export const cooperateDetail= function (params) {
  return $axios({
    url: '/api/yn/breed/cooperate_detail',
    method: 'GET',
    params
  })
}

//养母繁犊-金融机构页面左侧两个板块数据
export const getCrowTableList= function (params) {
  return $axios({
    url: '/api/yn/breed/cooperate_cows',
    method: 'GET',
    params
  })
}

//合作繁育详情页的牛只详情
export const getCrowTableDetail= function (params) {
  return $axios({
    url: '/api/yn/breed/cooperate_cow_detail',
    method: 'GET',
    params
  })
}

//合作繁育详情页的牛只详情
export const traceDetail= function (params) {
  return $axios({
    url: '/api/yn/product/detail',
    method: 'GET',
    params
  })
}

//合作繁育详情页的牛只详情
export const traceTableDetail= function (params) {
  return $axios({
    url: '/api/yn/product/breed_info',
    method: 'GET',
    params
  })
}

//nav 菜单
export const publicIndexNav= function () {
  return $axios({
    url: '/api/yn/index/menu',
    method: 'GET'
  })
}
//nav 菜单
export const publicHeaderText= function () {
  return $axios({
    url: '/api/yn/index/title',
    method: 'GET'
  })
}

//nav 屠宰加工页面数据
export const tuzaiPages= function () {
  return $axios({
    url: '/api/yn/tuzai/index',
    method: 'GET'
  })
}
//nav 牛只管控详情
export const manageDetail= function (params) {
  return $axios({
    url: '/api/yn/cow/health_detail',
    method: 'GET',
    params
  })
}

//中央厨房-料单管理列表
export const getManagesDownData= function (params) {
  return $axios({
    url: '/api/yn/cow/insurance',
    method: 'GET',
    params
  })
}

//养母繁犊-金融机构页面左侧两个板块数据
export const jinrongjgManagesData= function (params) {
  return $axios({
    url: '/api/yn/cow/insurance_basic',
    method: 'GET',
    params
  })
}
//牛只管理-金融列表-查看详情
export const jinrongjgManagesDetail= function (params) {
  return $axios({
    url: '/api/yn/cow/cooperate_detail',
    method: 'GET',
    params
  })
}

//牛只管理-销售溯源-list
export const tracelistTopData= function (params) {
  return $axios({
    url: '/api/yn/product/type_info',
    method: 'GET',
    params
  })
}

//牛只管理-养母繁犊-detail
export const calfDetailCrow= function (params) {
  return $axios({
    url: '/api/yn/breed/cooperate_cow_detail',
    method: 'GET',
    params
  })
}
